import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import condition from './Condition';
import {    reactLocalStorage  } from 'reactjs-localstorage';
import { connect } from 'react-redux';

class PrivateRouter extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        console.log("Route",this.props)
        var isLogin = condition();
        var paymentCheck = condition() && reactLocalStorage.get("Total") !== undefined;
        if(this.props.location.pathname.split('/')[1] !== "payment"){
            if(this.props.location.pathname === "/order/view-cart")  {
                return (
                    <Route render={props => (
                        this.props.state.cartItems.length ?
                            <Route exact={this.props.exact} component={this.props.component}  {...this.props} />
                            : <Redirect to="/" />
                    )} />
        
                );
            }  if(this.props.location.pathname === "/order/checkout")  {
                return (
                    <Route render={props => (
                        this.props.state.cartItems.length ?
                            <Route exact={this.props.exact} component={this.props.component}  {...this.props} />
                            : <Redirect to="/" />
                    )} />
        
                );
            } else {
                return (
                    <Route render={props => (
                        isLogin ?
                            <Route exact={this.props.exact} component={this.props.component}  {...this.props} />
                            : <Redirect to="/" />
                    )} />
        
                );
            }            
        } else {
            return (
                <Route render={props => (
                    paymentCheck ?
                        <Route exact={this.props.exact} component={this.props.component}  {...this.props} />
                        : <Redirect to="/" />
                )} />
    
            );
        }       
    }
}

const mapStateToProps = state => {
    console.log("PrivateRouter",state)
    return {
      state: state.AppReducer
    }
  };
  
  const mapDispatchToProps = dispatch => ({
  })
  
  export default connect(mapStateToProps, mapDispatchToProps)(PrivateRouter);